module.exports = __webpack_public_path__ + "static/media/rafflehouse-logo.09ae8d4f.svg";